import React from "react";
import { Star } from "lucide-react";

export const Stars = ({ value = 0, size = 14, className = "" }) => (
  <span className={`inline-flex items-center gap-0.5 ${className}`} dir="ltr">
    {[1, 2, 3, 4, 5].map((i) => (
      <Star key={i} size={size} className={i <= Math.round(value) ? "text-amber-400 fill-amber-400" : "text-gray-300"} />
    ))}
  </span>
);

const StarRating = ({ avg = 0, count = 0, size = 13, testid = "star-rating" }) => {
  if (!count) return null;
  return (
    <span className="inline-flex items-center gap-1" data-testid={testid}>
      <Stars value={avg} size={size} />
      <span className="text-xs text-[#666666] font-bold" dir="ltr">{Number(avg).toFixed(1)} ({count})</span>
    </span>
  );
};

export default StarRating;
